import { List, Map } from "immutable";
import { PluginStore } from "graylog-web-plugin/plugin";
import View from "views/logic/views/View";
import AddWidgetToDashboardTab from "views/logic/views/AddWidgetToDashboardTab";
import GetWidgetTitle from "views/logic/views/GetWidgetTitle";
import UpdateSearchForWidgets from "./UpdateSearchForWidgets";
import FindWidgetAndQueryIdInView from "./FindWidgetAndQueryIdInView";
const CopyWidgetToDashboard = (widgetId, source, destination) => {
  if (destination.type !== View.Type.Dashboard) {
    throw new Error(`Unexpected type ${destination.type} expected ${View.Type.Dashboard}`);
  }
  const copyHooks = PluginStore.exports("views.hooks.copyWidgetToDashboard");
  const queryMap = Map(source.search.queries.map((q) => [q.id, q]));
  const match = FindWidgetAndQueryIdInView(widgetId, source);
  if (match) {
    const [widget, queryId] = match;
    const { timerange, query, filter = Map(), filters } = queryMap.get(queryId);
    const { widgetPositions } = source.state.get(queryId);
    const oldPositions = widgetPositions[widgetId];
    const title = GetWidgetTitle(widgetId, queryId, source);
    const streams = (filter ? filter.get("filters", List.of()) : List.of()).filter((value) => Map.isMap(value) && value.get("type") === "stream").map((value) => value.get("id")).toList().toArray();
    const dashboardWidget = widget.toBuilder().newId().timerange(timerange).query(query).streams(streams).filters(filters).build();
    const updatedView = UpdateSearchForWidgets(
      AddWidgetToDashboardTab(dashboardWidget, void 0, destination, oldPositions, title)
    );
    return copyHooks.reduce((previousDashboard, copyHook) => copyHook(source, previousDashboard), updatedView);
  }
  return void 0;
};
export default CopyWidgetToDashboard;
